// extracted by mini-css-extract-plugin
module.exports = {"base":"MagazineHero_base__PhNcf","title":"MagazineHero_title__e2jYN","subtitle":"MagazineHero_subtitle__WLtWt","fixed":"MagazineHero_fixed__w9zkF"};